<template lang="html">
 <div class="layout-div__container">
                <div class="layout-div__title">
                    <span class="layout-span__title__text">
                        <i class="layout-i__line"><!-- 竖线 --></i>出油情况
                    </span>
                </div>
                <div class="layout-div__body sr-div__oil">
                    <div class="clearfix">
                        <img class="sr-img__girl" src="./imgs/report-img-girl@2x.png" alt="report img girl">

                        <div class="sr-img__oil" id="oilContainer">
                            <img class="sr-img__report__bg" src="./imgs/report-bg-oil@2x.png" id="oilImage" alt="出油情况">

                            <div class="sr-img__oil__loading__bg sr-face">
                                <div class="sr-img__oil__loading" id="face" :style="'width:'+oil.face+'%;'" data-percent="80"></div>
                                <i class="sr-img__loading__icon" :style="'right:'+oilTag.face+'%;'" id="face-loading">
                                    <img class="sr-img__oil__img" src="./imgs/report-bg-oilyield@2x.png" alt="">
                                    <span>{{oil.face}}</span>
                                </i>
                            </div>
                            <div class="sr-img__oil__loading__bg sr-t">
                                <div class="sr-img__oil__loading"  id="t" :style="'width:'+oil.tarea+'%'" data-percent="70"></div>
                                <i class="sr-img__loading__icon" :style="'right:'+oilTag.tarea+'%;'" id="t-loading">
                                    <img class="sr-img__oil__img" src="./imgs/report-bg-oilyield@2x.png" alt="">
                                    <span>{{oil.tarea}}</span>
                                </i>
                            </div>
                            <div class="sr-img__oil__loading__bg sr-chin">
                                <div class="sr-img__oil__loading" id="chin" :style="'width:'+oil.chin+'%;'" data-percent="100"></div>
                                <i class="sr-img__loading__icon" :style="'right:'+oilTag.chin+'%;'" id="chin-loading">
                                    <img class="sr-img__oil__img"  src="./imgs/report-bg-oilyield@2x.png" alt="">
                                    <span>{{oil.chin}}</span>
                                </i>
                            </div>
                        </div>
                    </div>

                    <ul class="sr-ul__result__group clearfix">
                        <li class="sr-li__result__item">
                            当前出油状态为 <i class="layout-i__font big-font">{{oil.oilLevel}}</i>
                        </li>
                        <li style="margin-top:5px;">
                            {{oil.oilAdvice}}
                        </li>
                    </ul>
                </div>
            </div>
</template>

<script>
/* eslint-disable */
export default {
  beforeMount() {
    let {
      cheek_oil_shine,
      tzone_oil_shine,
      chin_oil_shine,
      oil_level,
      short_oil_level_advice
    } = this.$store.state.result.resultData
    this.oil = {
      face: parseInt(cheek_oil_shine * 100),
      tarea: parseInt(tzone_oil_shine * 100),
      chin: parseInt(chin_oil_shine * 100),
      oilLevel: oil_level,
      oilAdvice: short_oil_level_advice
    };
    this.oilTag = {
      face: 88 - parseInt(cheek_oil_shine * 100),
      tarea: 88 - parseInt(tzone_oil_shine * 100),
      chin: 88 - parseInt(chin_oil_shine * 100)
    };
  },
  data() {
    return {
      oil: {
        face: 100,
        tarea: 0,
        chin: 0,
        oilLevel: "混合型",
        oilAdvice: "注意保养啊"
      },
      oilTag: {
        // 范围 88 - (-12), 对应 0 - 100
        face: -12,
        tarea: 88,
        chin: 88
      }
    };
  }
};
</script>

<style scoped>
.sr-div__oil {
  margin-top: 0.8rem;
}
.sr-img__girl {
  width: 33.6%;
  float: left;
}
.sr-img__oil {
  width: 64%;
  height: auto;
  float: right;
  position: relative;
}
.sr-img__oil__loading__bg {
  background-color: #f5f5f5;
  width: 73.5294%;
  position: absolute;
  right: 8.8235%;
  height: 3.75%;
}

.sr-face {
  top: 16.25%;
}
.sr-t {
  top: 40%;
}
.sr-chin {
  top: 63.75%;
}
.sr-img__oil__loading {
  height: 100%;
  width: 100%;
  display: block;
  background-color: #64c8c8;
  position: relative;
  border-radius: 0.8rem;
  box-shadow: 0.03rem 0.05rem 0.03rem #e3e3e3;
}
.sr-img__loading__icon {
  width: 24%;
  display: block;
  position: absolute;
  display: block;
  right: -10.6667%;
  top: -400%;
}
.sr-img__loading__icon image {
  width: 100%;
  height: auto;
  position: absolute;
}
.sr-img__loading__icon span {
  position: absolute;
  width: 100%;
  margin-top: -8.1vw;
  text-align: center;
  font-style: normal;
  color: #fff;
  z-index: 9;
  font-size: 3.2vw;
  text-shadow: none;
  font-weight: bold;
}
.sr-img__report__bg {
  width: 100%;
  /* height: auto; */
}
.sr-canvas__oil {
  width: 100%;
  height: 70%;
}
.sr-img__oil__img {
  width: 100%;
}
.sr-ul__result__group {
  margin: 0;
  padding: 0;
  display: block;
  list-style: none;
  margin-top: 8vw;
  font-size: 4vw;
  color: #323232;
  font-family: "PingFangSC";
}
.sr-li__result__item {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/oil.vue